//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import InterfaceEdit from '@/components/Resource/InterfaceEdit';
import MenuEdit from '@/components/Resource/MenuEdit';
export default {
  components: {
    SearchForm: SearchForm,
    InterfaceEdit: InterfaceEdit,
    MenuEdit: MenuEdit
  },
  data: function data() {
    return {
      activeName: 'first',
      ifReEdit: true,
      showInterface: false,
      ifMenuEdit: true,
      showMenu: false,
      // searchFormData: [
      //   {
      //     title: '系统名称',
      //     key: 'sysName',
      //     placeholder: '请选择系统名称',
      //     type: 'select',
      //     selectData: [],
      //     selectedArr: [],
      //     multiple: true
      //   },
      //   {
      //     title: '权限名称',
      //     key: 'role',
      //     placeholder: '请输入权限名称',
      //     type: 'input',
      //     value: null,
      //     selectData: [],
      //     selectedArr: [],
      //   },
      // ],
      // tableData:[
      //   {
      //     roleNum: '0000001',
      //     sysName: '法律合规门户',
      //     roleName: '总行超级管理员',
      //     roleType: '总行',
      //     roleExplain: '角色用户用于管理总行所有制度',
      //     roleStatus: '有效'
      //   }
      // ],
      btnType: 'add,search'
    };
  },
  methods: {
    searchForm: function searchForm() {},
    handleSelectionChange: function handleSelectionChange() {},
    tabsClickFn: function tabsClickFn() {},
    editInterfaceFn: function editInterfaceFn(obj) {
      this.showInterface = false;
      if (obj.bool) {
        // console.log("提交")
      } else {
        // console.log("取消")
      }
    },
    interfaceAddFn: function interfaceAddFn() {},
    interfaceEditFn: function interfaceEditFn(item, bool) {
      this.showInterface = true;
      this.ifReEdit = bool;
    },
    interfaceDelFn: function interfaceDelFn() {},
    delMenuFn: function delMenuFn() {},
    editMenuFn: function editMenuFn(item, bool) {
      this.showMenu = true;
      if (bool) {
        // console.log("编辑菜单")
      } else {
        // console.log("新增菜单")
      }
    },
    menuSubmitFn: function menuSubmitFn(obj) {
      this.showMenu = false;
      if (obj.bool) {
        // console.log("提交菜单")
      } else {
        // console.log("取消菜单")
      }
    }
  }
};